import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.css']
})
export class ConfirmModalComponent {
  @Input() headerText: string;
  @Input() bodyText: string;
  @Input() confirmButtonText: string = 'Confirm';
  @Input() cancelButtonText: string = 'Cancel';
  @Input() onConfirm: Function | null;
  @Input() warningLevel: string | null = null;
  confirmed: boolean = false;

  constructor(
    private ngbActiveModal: NgbActiveModal
  ) { }

  ngOnInit (): void {
  }

  saveAndCloseModal () {
    this.confirmed = true;
    if (this.onConfirm) {
      this.onConfirm()
    }
    this.closeModal()
  }

  closeModal () {
    this.ngbActiveModal.close(this.confirmed);
  }
}
